var exports = {
  "Q": "ChannelDuplicateModal.module__content___WEhuaF",
  "c": "ChannelDuplicateModal.module__helperText___WEhuaF",
};

module.exports = exports;
